import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-5" }
const _hoisted_4 = { class: "field-radiobutton" }
const _hoisted_5 = {
  key: 0,
  class: "p-field p-col-12 p-md-4"
}
const _hoisted_6 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_7 = { class: "p-input-icon-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách người đăng ký khám bệnh" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Chọn loại thời gian:", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RadioButton, {
                id: "city1",
                name: "city",
                value: "2",
                modelValue: $setup.kind,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.kind) = $event)),
                style: {"margin-right":"5px"},
                onChange: $setup.clearDate
              }, null, 8, ["modelValue", "onChange"]),
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "city1",
                style: {"margin-right":"20px"}
              }, "Thời gian theo ngày đặt lịch", -1)),
              _createVNode(_component_RadioButton, {
                id: "city2",
                name: "city",
                value: "1",
                modelValue: $setup.kind,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.kind) = $event)),
                style: {"margin-right":"5px"},
                onChange: $setup.clearDate
              }, null, 8, ["modelValue", "onChange"]),
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "city2" }, "Thời gian theo ngày liên hệ", -1))
            ])
          ]),
          ($setup.kind > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("label", null, "Chọn thời gian tìm kiếm: ", -1)),
                _createVNode(_component_Calendar, {
                  id: "date",
                  modelValue: $setup.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.date) = $event)),
                  selectionMode: "range",
                  dateFormat: "dd/mm/yy",
                  showButtonBar: true,
                  showIcon: true,
                  manualInput: false,
                  monthNavigator: true,
                  yearNavigator: true,
                  yearRange: "2000:2100",
                  onDateSelect: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectCalendar())),
                  onClearClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearCalendar()))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Chọn loại dịch vụ:", -1)),
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_Dropdown, {
                id: "dichvu",
                modelValue: $setup.service,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.service) = $event)),
                options: $setup.listService,
                optionLabel: "serviceName",
                optionValue: "serviceCode",
                placeholder: "Vui lòng chọn dịch vụ",
                emptyMessage: "Không có dữ liệu",
                onChange: $setup.getFilter,
                showClear: "true"
              }, null, 8, ["modelValue", "options", "onChange"])
            ])
          ])
        ]),
        _createVNode(_component_DataTable, {
          value: $setup.list,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['customerName','serviceName'],
          currentPageReportTemplate: "Có tất cả {totalRecords} người đăng ký",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event)),
          style: {"font-size":"13px"}
        }, {
          empty: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode(" Không có thông tin người bệnh. ")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "customerName",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "serviceName",
              header: "Tên dịch vụ",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "address",
              header: "Địa chỉ"
            }),
            _createVNode(_component_Column, {
              field: "year",
              header: "Năm sinh",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "antecedent",
              header: "Tiền sử bệnh"
            }),
            _createVNode(_component_Column, {
              field: "message",
              header: "Yêu cầu"
            }),
            _createVNode(_component_Column, {
              field: "phoneNumber",
              header: "Số điện thoại"
            }),
            _createVNode(_component_Column, {
              field: "userConfirm",
              header: "Người xác nhận",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "timeContact",
              dataType: "date",
              header: "Thời gian liên hệ",
              sortable: ""
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString($setup.formatDateTime(data.timeContact)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "timeBooking",
              dataType: "date",
              header: "Thời gian đặt lịch",
              sortable: ""
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString($setup.formatDateTime(data.timeBooking)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  style: {"text-decoration":"none !important"},
                  to: { name: 'updateregisterservice', params: {id: slotProps.data.id}}
                }, {
                  default: _withCtx(() => [
                    (!$setup.validDate(slotProps.data))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "button",
                          label: "Đặt lịch",
                          icon: "pi pi-spinner"
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          type: "button",
                          label: "Đổi lịch",
                          class: "p-button-secondary",
                          icon: "pi pi-check-circle"
                        }))
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"])
      ])
    ]),
    _: 1
  }))
}